module.exports = __webpack_public_path__ + "static/media/bio_fiona_1.74b55192.jpg";